__turbopack_context__.v({
  "fadeIn": "FadeIn-module__p8chMq__fadeIn",
});
